import { useMemo } from "react";
import { useSocialCoachSession } from "./useSocialCoachSession";
import { useAccountSettings } from "./useAccountSettings";
import { WebComponents, WebSettings } from "@/interfaces";

export const useCanImpersonate = () => {
  const { isAdmin, isCoach, isAssistantCoach } = useSocialCoachSession();
  const { hasReadPermission, hasAccountSetting } = useAccountSettings();

  return useMemo(() => {
    // Admins and Coaches can always impersonate players
    if (isAdmin) return true;

    if (isCoach) {
      return hasAccountSetting(WebSettings.ALLOW_IMPERSONATION);
    }

    // Assistant Coaches must have explicit WebComponents.IMPERSONATE_PLAYERS read permissions
    if (isAssistantCoach) {
      return hasAccountSetting(WebSettings.ALLOW_IMPERSONATION) && hasReadPermission(WebComponents.IMPERSONATE_PLAYERS);
    }

    return false;
  }, [isAdmin, isCoach, isAssistantCoach, hasReadPermission]);
};
